import { render, staticRenderFns } from "./AttributeForm.vue?vue&type=template&id=2c7330e0&scoped=true&"
import script from "./AttributeForm.vue?vue&type=script&lang=js&"
export * from "./AttributeForm.vue?vue&type=script&lang=js&"
import style0 from "./AttributeForm.vue?vue&type=style&index=0&id=2c7330e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7330e0",
  null
  
)

export default component.exports